<template>
  <div class="sms_template_list">
    <el-card  >
      <nav class="input" style="width: auto">
        <el-button type="primary" size="small" @click="$router.push('/exhibition_add_exhibition')">新增展会</el-button>
      </nav>
    </el-card>
    <el-card style="margin-top: 10px">
      <z-table ref="table" v-model="list" @query="queryList" fullscreenLoading>
        <el-table :data="list" style="width: 100%" border stripe :header-cell-style="rowClass">
          <el-table-column prop="id" label="ID" width="80px"> </el-table-column>
          <el-table-column prop="name" label="展会名称" width="250px"> </el-table-column>
          <el-table-column prop="activity_name" label="关联活动"> </el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="220px"> </el-table-column>
          <el-table-column label="操作"  width="450px">
            <template slot-scope="{ row }">
              <el-button @click="onEdit('partner_list',row)" type="text" icon="el-icon-user" size="mini">合作方名单</el-button>
              <el-button @click="onEdit('exhibitior_list',row)" type="text" icon="el-icon-user" size="mini">展商名单</el-button>
              <el-button @click="handleDownloadFile('poster',row)" type="text"  size="mini">展商海报和logo批量下载</el-button>
              <el-button @click="handleDownloadFile('all',row)" type="text"  size="mini">物料下载</el-button>
              <el-button @click="handleDownloadFile('base',row)" type="text"  size="mini">基础信息下载</el-button>
              <el-button @click="handleDownloadFile('signInCode',row)" type="text"  size="mini">展商签到码下载</el-button>
              <el-button @click="handleDownloadFile('gifts',row)" type="text"  size="mini">批量导出展商互动/企服赞助信息</el-button>
              <el-button @click="handleView(row)" type="text"  size="mini">查看审核状态</el-button>
<!--              <el-button @click="handleSignInRecord(row)" type="text"  size="mini">签到记录</el-button>-->
              <el-button @click="onEditExhi(row)" type="text" icon="el-icon-edit" size="mini">编辑</el-button>
              <el-button
                  @click="onDelete(row)"
                  type="text"
                  icon="el-icon-delete"
                  size="mini"
                  v-show="$store.state.btn_if.indexOf('exhibition_delete') != -1"
                  style="color: red;"
              >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </z-table>
    </el-card>
    <el-dialog
        title="添加展会"
        :visible.sync="addEnterpriseDialogVisible"
        width="30%"
        center>
      <el-input v-model="exhibitorForm.name" size="medium" style="width: 512px" placeholder="请输入展会名称" />
      <div class="input-detail" >
        <input placeholder="输入活动名称模糊查询" class="clear-input"
               v-model="state"  type="text" name="" id=""
               @input="querySearchAsync" @blur="toClose" />
        <div class="theSearchBox" v-show="searchInput">
          <div class="item flex-align" v-for="(item, index) in searchList" :key="item.id">
            <img :src="baseurl + yu +item.banner" alt="" />

            <div class="desc clamp-1">{{ item.title }}</div>
            <div class="btn" @click="add(item)">添加</div>
          </div>
<!--          <div class="foot">-->
<!--            <div class="add-text">搜索不到您要添加的企业，请联系客服添加</div>-->
<!--            <img src="https://cdn-img.yfchuhai.com/www.yfchuhai.com/static/pc/img/index/grounp/anan_code.jpg" alt="" />-->
<!--            &lt;!&ndash; <span style="flex: 1; font-size: 18px; color: #333333">搜索不到您要添加的企业</span>-->
<!--            <div class="undata" @click.stop="manuallyAdd">手动添加</div> &ndash;&gt;-->
<!--          </div>-->
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="addEnterpriseDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="addEnterprise">确 定</el-button>
  </span>
    </el-dialog>
    <el-dialog
        title="展商列表"
        :visible.sync="addEnterpriseVisible"
        width="60%"
        @close="toggleSelection()"
        center>
      <nav class="input" style="width: auto">
        <el-input v-model="exhibitorListSearch.keyword" size="medium" placeholder="请输入企业名称/展位号" />
      </nav>
      <nav class="input" style="width: 250px">
        <el-button size="small" @click="resetList">重置</el-button>
        <el-button type="primary" size="small" @click="$refs.exhibitorTable.reload()">{{ "搜索" }}</el-button>
        <el-button type="primary" v-if="type=='signInCode' || type=='base' || type=='gifts'" size="small" @click="handleDownloadFileAll">{{ "导出全部" }}</el-button>
      </nav>

      <z-table ref="exhibitorTable" v-model="exhibitorList" @query="getQueryList" fullscreenLoading>
        <el-table
            ref="multipleTable"
            :row-key="getRowKey"
            @selection-change="handleSelectionChange"
            :data="exhibitorList" style="width: 100%" border stripe :header-cell-style="rowClass">
          <el-table-column
              type="selection"
              width="55"
              :reserve-selection="true">
          </el-table-column>
          <el-table-column prop="id" label="ID" > </el-table-column>
          <el-table-column prop="enterpriseName" label="绑定企业"> </el-table-column>
          <el-table-column prop="code" label="展位号"> </el-table-column>
          <el-table-column prop="eaName" label="账号"> </el-table-column>
          <el-table-column prop="createTime" label="创建时间"> </el-table-column>
        </el-table>
      </z-table>
      <span slot="footer" class="dialog-footer">
    <el-button @click="toggleSelection()">取 消</el-button>
        <el-button type="primary" @click="downloadFile">确 定</el-button>
  </span>
    </el-dialog>
    <el-dialog
        title="展商审核状态"
        :visible.sync="examineEnterpriseVisible"
        width="60%"
        center>
      <nav class="input" style="width: auto">
        <el-input v-model="examineEnterpriseSearch.keyword" size="medium" placeholder="请输入企业名称" />
      </nav>
      <nav class="input" style="width: auto">
        <el-select
            style="width: 100%"
            v-model="examineEnterpriseSearch.type" placeholder="请选择模块" size="medium"
        >
          <el-option label="基础信息" value="information" />
          <el-option label="会刊" value="guide" />
          <el-option label="物料" value="material" />
          <el-option label="结果" value="result" />
        </el-select>
      </nav>
      <nav class="input" style="width: auto">
        <el-select
            style="width: 100%"
            v-model="examineEnterpriseSearch.status" placeholder="状态" size="medium"
        >
          <el-option label="待上传" value="0" />
          <el-option label="审核通过" value="2" />
          <el-option label="待审核" value="1" />
          <el-option label="审核不通过" value="3" />
        </el-select>
      </nav>

      <nav class="input" style="width: 150px">
        <el-button size="small" @click="resetexamineEnterpriseSearch">重置</el-button>
        <el-button type="primary" size="small" @click="$refs.examineEnterprise.reload()">{{ "搜索" }}</el-button>
      </nav>
      <z-table ref="examineEnterprise" v-model="exhibitorExamineList" @query="getViewExhibitorApprovalStatus" fullscreenLoading>
        <el-table
            :data="exhibitorExamineList" style="width: 100%" border stripe :header-cell-style="rowClass">
          <el-table-column prop="name" label="展商账号" > </el-table-column>
          <el-table-column prop="enterpriseName" label="公司" > </el-table-column>
          <el-table-column prop="code" label="展位号" > </el-table-column>
          <el-table-column prop="enterpriseName" label="基础信息">
            <template slot-scope="{ row }">
              <el-tooltip  class="item" effect="dark" :content="row.informationRefuseReason?row.informationRefuseReason:'暂无'" placement="top">
                <div class="clamp-1">
                  <el-tag :type="statusChange(row.informationApprove).type ">{{statusChange(row.informationApprove).name  }}</el-tag>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="code" label="会刊">
            <template slot-scope="{ row }">
              <el-tooltip  class="item" effect="dark" :content="row.guideRefuseReason?row.guideRefuseReason:'暂无'" placement="top">
                <div class="clamp-1">
                  <el-tag :type="statusChange(row.guideApprove).type ">{{statusChange(row.guideApprove).name  }}</el-tag>

                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="eaName" label="物料">
            <template slot-scope="{ row }">
              <!--            <b-code-editor v-model="row.search" :auto-format="true" :smart-indent="true" theme="dracula" :indent-unit="4" :line-wrap="false" ref="editor"></b-code-editor>-->
              <el-tooltip  class="item" effect="dark" :content="row.informationRefuseReason?row.informationRefuseReason:'暂无'" placement="top">
                <div class="clamp-1">
                  <el-tag :type="statusChange(row.materialApprove).type ">{{statusChange(row.materialApprove).name  }}</el-tag>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="eaName" label="结果">
            <template slot-scope="{ row }">
              <div class="clamp-1">
                <el-tag :type="statusChange(row.totalStatus).type ">{{statusChange(row.totalStatus).name  }}</el-tag>
                </div>
            </template>
          </el-table-column>
        </el-table>
      </z-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="examineEnterpriseVisible=false">关闭</el-button>
  </span>
    </el-dialog>
    <el-dialog
        title="用户签到数据"
        :visible.sync="examineSignVisible"
        width="60%"
        center>
      <nav class="input" style="width: auto">
        <el-input v-model="examineEnterpriseSearch.keyword" size="medium" placeholder="请输入姓名/手机号码" />
      </nav>


      <nav class="input" style="width: 150px">
        <el-button size="small" @click="resetexamineEnterpriseSearch">重置</el-button>
        <el-button type="primary" size="small" @click="$refs.examineSign.reload()">{{ "搜索" }}</el-button>
      </nav>
      <z-table ref="examineSign" v-model="signList" @query="getSignUserLogLists" fullscreenLoading>
        <el-table
            :data="signList" style="width: 100%" border stripe :header-cell-style="rowClass">
          <el-table-column prop="username" label="用户名" > </el-table-column>
          <el-table-column prop="user_phone" label="手机号码" > </el-table-column>
          <el-table-column prop="source" label="签到来源" >
            <template slot-scope="{ row }">
              {{row.source}}<span v-if="row.point">
              -{{row.point}}
            </span>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="签到方式" > </el-table-column>
          <el-table-column prop="time" label="签到时间"></el-table-column>
          <el-table-column prop="category" label="备注">
            <template slot-scope="{ row }">
              <el-tag v-if="row.category" >{{row.category==1?'核销':'加积分'}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="category" label="积分">
            <template slot-scope="{ row }">
              <el-tag :type="row.category==1?'danger':'success'" v-if="row.category" >{{row.category==1?'-':'+'}}{{row.integral}}</el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="code" label="活动">
            <template slot-scope="{ row }">
              <el-tag v-if="row.activity_title" >{{row.activity_title}}</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </z-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="examineSignVisible=false">关闭</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import list from "/src/mixin/list.js";
import {debounce} from "@/utils/methods";
import Img from "@/views/enterprise/enterprise_cert_list/img.vue";
import exhibitor from "@/views/enterprise/exhibitor.vue";
import log from "@/views/activity/activity_speaker_ppt/log.vue";
import da from "element-ui/src/locale/lang/da";
export default {
  computed: {
    exhibitor() {
      return exhibitor
    },
    statusChange(val){
      return (val) => {
        var key;
        switch (val) {
          case 0:
            key = {
            name:'未上传',
                type:""
          };
            break;
          case 1:
            key = {
              name:'待审批',
              type:"warning"
            };
            break;
          case 2:
            key =  {
            name:'审批通过',
                type:"success"
          };
            break;
          case 3:
            key =
          {
            name:'审批不通过',
                type:"danger"
          };
            break;
        }
        return key;
      };
    },
  },
  components: {Img},
  mixins: [list],
  data() {
    return {
      examineSignVisible:false,
      examineEnterpriseVisible: false,
      exhibitorExamineList: [],
      signList:[],
      // 展商列表
      exhibitorList:[],
      examineEnterpriseSearch:{
        keyword:'',
        status:'',
        type:''
      },
      exhibitorListSearch:{
        keyword:''
      },
      search: {
      },
      addForm:{
        categoryId:"1",
        enterpriseId:""
      },
      exhibitorForm:{
        name:"",
        activityId:""
      },
      exhibitorSearch:{
        page:1,
        pageSize:10,
        keyword:"",
        exhibitionId:""
      },
      addEnterpriseDialogVisible:false,
      addEnterpriseVisible:false,
      state:"",
      searchList:[],
      searchInput:false,
      exhibitorName:"",
      baseurl: this.$store.state.env.cdnImg,
      yu: "/" + this.$store.state.env.domain,
      enterpriseList:[],
      pageStatus:1,
      dialogType:1,
      currentId:0,
type:'poster',

    };
  },
  activated() {
    console.log(1);
  },
  created() {
  },

  methods: {
    handleView(row){
      this.examineEnterpriseVisible=true
      this.exhibitorListSearch.exhibitionId=row.id
    },
    handleSignInRecord(row){
this.examineSignVisible=true
      this.exhibitorListSearch.exhibitionId=row.id
    },
    handleDownloadFile(type,row){
      this.type=type
      this.currentId=row.id
      this.exhibitorListSearch.exhibitionId=row.id
      this.addEnterpriseVisible=true
    },
    /**
     * 绑定row-key 表格中每一条数据是唯一值
     * @param row
     * @returns {*}
     */
    getRowKey(row) {
      return row.id;
    },
    resetexamineEnterpriseSearch(){
      this.examineEnterpriseSearch = {
        keyword:'',
        status:'',
        type:''
      }
      this.getViewExhibitorApprovalStatus({
        page:1,
        pageSize:10
      })
      this.getSignUserLogLists({
        page:1,
        pageSize:10
      })
    },
    resetList(){
      this.exhibitorListSearch.keyword=''
          this.getQueryList({
            page:1,
            pageSize:10
          })
    },
    async getViewExhibitorApprovalStatus(val){
  let { data: res } = await this.$http.get("/admin/Exhibition/viewExhibitorApprovalStatus",{
    params:{exhibition_id:this.exhibitorListSearch.exhibitionId,
      ...this.examineEnterpriseSearch,
    ...val}
  });
  if (res.errorCode == 200) {
    console.log(res.data)
    this.$refs.examineEnterprise.complete(res.data);
  }
},
    async getSignUserLogLists(val){
      let { data: res } = await this.$http.get("/admin/Exhibition/getSignUserLogLists",{
        params:{exhibition_id:this.exhibitorListSearch.exhibitionId,
          keyword:this.examineEnterpriseSearch.keyword,
          ...val}
      });
      if (res.errorCode == 200) {
        console.log(res.data)
        this.$refs.examineSign.complete(res.data);
      }
    },
    /**
     * 获取展商列表
     * @param val
     * @returns {Promise<void>}
     */
    async getQueryList(val) {
      let { data: res } = await this.$http.get("/admin/Exhibition/getExhibitorList", {
        params: { ...val, ...this.exhibitorListSearch },
      });
      if (res.errorCode == 200) {
        console.log(res.data.list)
        this.$refs.exhibitorTable.complete(res.data);
      }

    },
    // 多选
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
      this.addEnterpriseVisible=false
    },
    /**
     * 对话框表格多选
     * @param val
     */
    handleSelectionChange(val) {
      this.multipleSelection=val
      // this.multipleSelection=JSON.parse(localStorage.getItem("selectArr")) || [];
      // this.multipleSelection.forEach((row)=>{
      //   this.$refs.multipleTable.toggleRowSelection(row, true);
      // })
      // // this.multipleSelection=val
      // localStorage.setItem("selectArr", JSON.stringify(this.multipleSelection));

    },
    handleDownloadFileAll(){
      this.multipleSelection=[{id:0}]
      this.downloadFile()
    },
    /**
     * 物料下载
     */
    async downloadFile(row){
      this.addEnterpriseVisible=false
      var url
      if (this.type=='all'){
        const data= await this.$http.get("/admin/Exhibition/batchDownloadExhibitorMaterial",{params:{
            exhibition_id:this.exhibitorListSearch.exhibitionId,
            ids:this.multipleSelection.map(item=>item.id).join(',')
          }});
        url=data.data.data.url
      }else if(this.type=='base'){
        const data= await this.$http.get("/admin/Exhibition/batchExportExhibitionBasics",{params:{
            exhibition_id:this.exhibitorListSearch.exhibitionId,
            ids:this.multipleSelection.map(item=>item.id).join(',')
          }});
        url=data.data.data.url
      }else if(this.type == 'signInCode'){
        const data= await this.$http.get("/admin/Exhibition/batchExportExhibitionSign",{params:{
            exhibition_id:this.exhibitorListSearch.exhibitionId,
            ids:this.multipleSelection.map(item=>item.id).join(',')
          }});
        url=data.data.data.url
      }else if(this.type == 'gifts'){
        const data= await this.$http.get("/admin/Exhibition/batchExportExhibitionMaterial",{params:{
            exhibition_id:this.exhibitorListSearch.exhibitionId,
            ids:this.multipleSelection.map(item=>item.id).join(',')
          }});
        url=data.data.data.url
      }
      else {
        const data= await this.$http.get("/admin/Exhibition/batchDownloadExhibitorPosterLogo",{params:{
            exhibition_id:this.exhibitorListSearch.exhibitionId,
            ids:this.multipleSelection.map(item=>item.id).join(',')
          }});
        url=data.data.data.url
      }
      console.log(url)

      if (url){
        let link = document.createElement("a"); //创建a标签
        link.style.display = "none"; //使其隐藏
        link.href = url; //赋予文件下载地址
        link.setAttribute("download", url); //设置下载属性 以及文件名
        document.body.appendChild(link); //a标签插至页面中
        link.click(); //强制触发a标签事件
      }
    },
    onEditExhi(row){
      console.log(row);
      this.$router.push({ name: "exhibition_add_exhibition", query: { id: row.id } });
    },
    onEdit(url,row) {
      this.$router.push({ name:url, query: { id: row.id } });
    },
    async exhibitorList(){
      let { data: res } = await this.$http.post("/admin/Exhibition/getExhibitorList",{...this.exhibitorSearch});

    },

    /**
     *
     */
    handleExhibitorList(row){
      this.pageStatus=2
      this.exhibitorSearch.exhibitionId=row.id
      this.exhibitorList()

    },
    /**
     *活动搜索
     */
    querySearchAsync: debounce(async function () {
      this.state=this.state.trim()
      const { data } = await this.$http.get(
          '/admin/Activity/getList' ,{params:{
              page:'1',
              pageSize:'5',
              eventDate: "",
              publishDate: "",
              title:this.state,
              publishStatus: "",
              checkStatus: "",
              acId: "",
              orvalueder: ""}}
      );
      this.searchList = data.data.list;
      this.searchInput = true;
    }),

    // 关联活动
    async add(row) {
      this.state=row.title
      this.exhibitorForm.activityId=row.id
      this.searchInput=false
    },
    toClose() {
      setTimeout(() => {
        this.searchInput = false;
      }, 300);
    },
    /**
     * 添加展会
     * @returns {Promise<void>}
     */
    async addEnterprise(){
      console.log(this.dialogType)
      if(this.dialogType){
        let { data: res } = await this.$http.post("/admin/Exhibition/addExhibition",{...this.exhibitorForm});
      }else {
        let { data: res } = await this.$http.post("/admin/Exhibition/editExhibition",{...this.exhibitorForm});

      }
      this.exhibitorForm={
        name:"",
        activityId:""
      },
          this.dialogType=1
          this.state=""
      this.addEnterpriseDialogVisible=false
      this.getlist()

    },
    // 获取展会列表
    getlist() {
      this.$refs.table.refresh();
      console.log(this.search)
      console.log(this.voteCategoryList)
    },
    // 获取展会展商名单
    getExhibitorList(){
      this.$refs.exhibitorTable.refresh();
    },
    async queryList(val) {
      let { data: res } = await this.$http.get("/admin/Exhibition/getExhibitionList", {
        params: { ...val, ...this.search },
      });
      if (res.errorCode == 200) {
        // this.$message.success(res.message);
        this.$refs.table.complete(res.data);
      }
    },
    /**
     * 删除展会
     * @param row
     * @returns {Promise<void>}
     */
    async onDelete(row) {
      await this.$confirm("此操作将永久删除该, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      let { data: res } = await this.$http.post("/admin/Exhibition/delExhibition", row);
      if (res.errorCode == 200) {
        this.$message.success(res.message);
        this.getlist();
      }
    },
  },
};
</script>

<style lang="less" scoped>

.logo-img{
  width: 60px;
  height: 60px;
}
.input-detail {
  margin-top: 20px;
  width: 98%;
  height: 38px;
  background: #ffffff;
  border: 1px solid #dcdfe6;
  padding-left: 16px;
  position: relative;
  margin-bottom: 30px;
  z-index: 2;

  input {
    &::placeholder {
      color: #9EA2B5;
    }
  }

  input {
    width: 100%;
    height: 100%;
    border: 0;
    outline: 0;
    background-color: transparent;
    &::-webkit-input-placeholder {
      font-size: 14px;
      font-weight: 500;
      color: #999999;
    }
  }
}
:deep(.el-card .el-card__body){
  padding: 0 30px;
}
.input-tip {
  color: #9EA2B5;
  font-size: 14px;
  margin-top: 17px;
  line-height: 1.5;
  span{
    color: #E2241B;
  }
}
.theSearchBox {
  width: 368px;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
  border-radius: 15px;
  padding: 20px 25px;
  position: absolute;
  top: 47px;
  left: 0px;

  .undata {
    width: 89px;
    height: 34px;
    background: #0a7ff2;
    border-radius: 17px;
    color: #fff;
    line-height: 34px;
    text-align: center;
    cursor: pointer;
  }

  .foot {
    margin-top: 20px;
    text-align: center;

    .add-text {
      color: #333333;
      font-size: 16px;
    }

    img {
      width: 165px;
      height: 165px;
      margin-top: 30px;
    }


  }
  .item {
    // margin-bottom: 30px;
    padding: 15px 0;
    border-bottom: 1px solid rgba(229, 229, 229, 0.6);

    &:first-child {
      padding-top: 0;
    }

    img {
      width: 54px;
      height: 54px;
      border-radius: 10px;
      flex-shrink: 0;
    }

    .desc {
      font-size: 18px;
      font-weight: 400;
      color: #333333;
      margin-left: 22px;
      width: 154px;
    }

    .btn {
      width: 90px;
      height: 35px;
      border: 1px solid #0a7ff2;
      border-radius: 17px;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      color: #0a7ff2;
      line-height: 35px;
      margin-left: auto;
      flex-shrink: 0;
    }
  }
}
.list {
  margin-top: 30px;
  display: grid;
  grid-template-columns: repeat(3,1fr);
  grid-gap: 10px;
  .list-item {
    flex-direction: column;
    width: 100px;
    height: 100px;
    background: #ffffff;
    border: 1px solid #f2f2f2;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    margin-right: 10px;
    margin-bottom: 10px;
    padding: 10px;
    display: flex;

    &:hover {
      .box {
        display: flex;
      }
    }

    >img {
      width: 80px;
      height: 80px;
      border-radius: 6px;
      margin-bottom: 5px;
    }

    .desc {
      width: 90px;
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      overflow: hidden;
      white-space: nowrap;
      text-overflow:ellipsis;
      text-align: center;
    }

    .box {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);

      .btn {
        width: 100px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        background: #ffffff;
        border-radius: 21px;
        color: #0a7ff2;
        font-size: 18px;
      }
    }
  }
}
</style>
